export default "__VITE_ASSET__4b62c784__"